import { useState, useEffect } from 'react';
import { supabase } from './supabase';
import { getAuthUser } from './tenant';
import { effectivePermissions, normalizeRole } from './permissions';

// Loads the current user's role + any per-user permission grants the owner gave
// them, and exposes can(permissionKey) over the merged (effective) set.
export function usePermissions() {
  const [role, setRole] = useState(null);
  const [extra, setExtra] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    // getAuthUser() answers from the local session instead of hitting
    // /auth/v1/user; the permissions row itself is still re-read on every mount,
    // so a grant the owner changes still lands on the next navigation.
    getAuthUser().then((user) => {
      if (!user) { if (active) setLoading(false); return; }
      supabase.from('profiles').select('role, permissions').eq('id', user.id).single()
        .then(({ data }) => {
          if (!active) return;
          setRole(normalizeRole(data?.role));
          setExtra(Array.isArray(data?.permissions) ? data.permissions : []);
          setLoading(false);
        });
    });
    return () => { active = false; };
  }, []);

  const perms = role ? effectivePermissions(role, extra) : [];
  return { role, perms, loading, can: (key) => perms.includes(key) };
}
